import React from 'react'
import style from "./css/WhyUs.module.css";

function WhyUs() {
    const Details = [
        {
            id: 1,
            image: './img/UpgradationOfCourses.png',
            paragraph: 'Up-Gradation of courses'

        },
        {
            id: 2,
            image: ' ./img/JobAssistance.png',
            paragraph: '100% Job Assistance'

        },
        {
            id: 3,
            image: './img/PracticalTraining.png',
            paragraph: '100% Practical Training'

        },
        {
            id: 4,
            image: './img/SmallBatchesForPersonalizedAttention.png',
            paragraph: 'Small Batches For Personalised Attention'

        },
    ]
    return (
        <>
            <div className="container-fluid bg-dark text-white">
                <div className={`${style.container} container p-4`}>
                    <div className="row align-content-center">
                        <h2 className='text-center text-warning p-4'> Why Us</h2>
                        {Details.map((e) => (
                            <div className='col-lg-3 col-md-6' key={e.id}>
                                <div className="align-content-center">
                                    <img src={e.image} alt="" className='d-block'/>
                                    <p>{e.paragraph}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhyUs
